<template>
  <div>
    <div class="p-1">
      <b-row>
        <template v-for="(option, index) in optionsCard">
          <b-col :key="index" cols="3">
            <div
              style="position: relative"
              :key="'content-' + index"
              class="parent-card"
              @click="changeSelectedCard(option.key)"
            >
              <b-card
                :bg-variant="isDarkSkin ? 'dark' : 'light'"
                :text-variant="isDarkSkin ? 'dark' : 'white'"
                :class="[classCardSelected(option.key), '']"
              >
                <div>
                  <b-card-title class="mb-0 mt-0">
                    <div class="d-flex justify-content-between">
                      <h3>{{ $t(option.title) }}</h3>
                      <tabler-icon
                        :icon="option.icon"
                        class="text-primary"
                        size="35"
                      />
                    </div>
                  </b-card-title>

                  <div class="d-flex justify-content-between text-center mt-1">
                    <strong> {{ $t("Quantity") }}: </strong>
                    <span class="text-primary" style="font-size: 17px">{{
                      option.quantity
                    }}</span>
                  </div>
                </div>
              </b-card>
            </div>
          </b-col>
        </template>
      </b-row>
    </div>

    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-vehicles'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-vehicles"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="getFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          primary-key="district_id"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(name)="data">
            <span class="text-warning"> {{ data.item.name }} </span>
          </template>

          <template #cell(vehicle_models)="data">
            <div
              v-if="cardSelected == 'brands_models' && data.item.vehicle_models"
            >
              <b-badge
                v-for="(mod, index) in JSON.parse(data.item.vehicle_models)"
                :key="index"
                pill
                :variant="`light-primary`"
                class="mr-1"
              >
                {{ mod.name }}
              </b-badge>
            </div>
          </template>
          <template #cell(amount)="data">
            <span class="text-primary">
              S/ {{ data.item.amount | currency }}
            </span>
          </template>
          <template #cell(created_at)="data">
            <span style="opacity: 0.7">
              {{ data.item.created_at | myGlobalDay }}
            </span>
          </template>
          <template #cell(code)="data">
            <b-badge variant="light-warning">
              {{ data.item.code }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <!-- Edit vehicles -->
            <feather-icon
              v-if="cardSelected == 'vehicles'"
              icon="EditIcon"
              size="18"
              class="text-warning cursor-pointer"
              @click="editVehicle(data.item.id)"
            />
            <!-- Edit zones -->
            <feather-icon
              v-if="cardSelected == 'zones'"
              icon="EditIcon"
              size="18"
              class="text-warning cursor-pointer"
              @click="editZone(data.item)"
            />

            <!-- Edit vehicle type -->
            <feather-icon
              v-if="cardSelected == 'types'"
              icon="EditIcon"
              size="18"
              class="text-warning cursor-pointer"
              @click="editVehicleType(data.item)"
            />

            <!-- Edit brand -->
            <feather-icon
              v-if="cardSelected == 'brands_models'"
              icon="EditIcon"
              size="18"
              class="text-warning cursor-pointer"
              @click="editBrand(data.item)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <ZonesModal
      v-if="showZonesModal == true"
      :zoneId="zoneId"
      @refreshTable="refreshTable()"
      @hideModal="hideModal"
    />

    <RoutesModal
      v-if="routeModal"
      :routeId="routeId"
      @registered="refreshTable()"
      @hideModal="routeModal = false"
    />

    <LocationsCodeModal
      v-if="showLocationCodesModal"
      @hideModal="showLocationCodesModal = false"
    />
    <RateModal
      v-if="rateModal"
      :rateId="rateId"
      @registered="refreshTable()"
      @hideModal="rateModal = false"
    />

    <VehicleBrandModal
      v-if="showBrandModal"
      :brandID="brandId"
      @hideModal="showBrandModal = false"
      @registered="refreshTable()"
    />

    <VehicleTypeModal
      v-if="showVehicleTypeModal"
      :vehicleTypeId="vehicleTypeId"
      @hideModal="showVehicleTypeModal = false"
      @registered="refreshTable()"
    />

    <VehicleSidebar
      v-if="showVehicleSidebar"
      :vehicleId="vehicleId"
      @hideSidebar="showVehicleSidebar = false"
      @updateVehicle="(showVehicleSidebar = false), refreshTable()"
      @createVehicle="(showVehicleSidebar = false), refreshTable()"
    />
  </div>
</template>
<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/commons/vehicles/data/vehicles.fields.js";
import TravelRouteService from "@/views/settings/views/travel-routes/services/travel-routes.service.js";
import ZonesModal from "@/views/settings/views/travel-routes/modals/ZoneModal.vue";
import RoutesModal from "@/views/settings/views/travel-routes/modals/RouteModal.vue";
import LocationsCodeModal from "@/views/settings/views/travel-routes/modals/LocationsCode.vue";
import RateModal from "@/views/settings/views/travel-routes/modals/RateModal.vue";

import VehicleBrandModal from "@/views/commons/vehicles/components/modals/VehicleBrandModal.vue";
import VehicleTypeModal from "@/views/commons/vehicles/components/modals/VehicleTypeModal.vue";
import VehicleService from "@/views/commons/vehicles/services/vehicle.service.js";
import VehicleSidebar from "@/views/commons/vehicles/components/modals/VehicleSidebar.vue";

export default {
  components: {
    ZonesModal,
    FilterSlot,
    RoutesModal,
    LocationsCodeModal,
    RateModal,
    VehicleBrandModal,
    VehicleTypeModal,
    VehicleSidebar,
  },
  data() {
    return {
      filters: [],
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      showZonesModal: false,
      zoneId: null,
      cardSelected: "vehicles",
      optionsCard: [],
      routeId: null,
      routeModal: false,
      showLocationCodesModal: false,
      rateId: null,
      rateModal: false,
      brandId: null,
      vehicleId: null,
      vehicleTypeId: null,
      showVehicleTypeModal: false,
      showBrandModal: false,
      showVehicleModal: false,
      showVehicleSidebar: false,
    };
  },
  async created() {
    this.generateOptionsCard();
    // await this.getRegisteredQantitiesOfCards();
  },
  computed: {
    getFields() {
      this.fields.map((f) => (f.visible = false));

      switch (this.cardSelected) {
        case "vehicles":
          this.fields[2].visible = true;
          this.fields[3].visible = true;
          this.fields[4].visible = true;
          this.fields[5].visible = true;
          this.fields[6].visible = true;
          this.fields[7].visible = true;
          this.fields[8].visible = true;
          this.fields[9].visible = true;
          break;
        case "types":
          this.fields[0].visible = true;
          // this.fields[2].visible = true;
          this.fields[9].visible = true;
          break;
        case "brands_models":
          this.fields[0].visible = true;
          this.fields[1].visible = true;
          this.fields[9].visible = true;
          break;
        default:
          break;
      }

      return this.fields.filter((f) => f.visible == true);
    },
  },
  methods: {
    generateOptionsCard() {
      this.optionsCard = [
        {
          key: "vehicles",
          title: "Vehicles",
          icon: "TruckIcon",
          quantity: 0,
        },
        {
          key: "types",
          title: "Vehicle Types",
          icon: "Layout2Icon",
          quantity: 0,
        },
        {
          key: "brands_models",
          title: "Brands & Models",
          icon: "RouteIcon",
          quantity: 0,
        },
      ];
    },

    async myProvider(ctx) {
      try {
        const optionApi = this.getOptionApi();
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: 1,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: 1,
          from: null,
          to: null,
        };

        const { data } = await VehicleService[optionApi](params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
        this.showToastError();
      } finally {
        this.removePreloader();
      }
    },

    getOptionApi() {
      let optionApi;
      switch (this.cardSelected) {
        case "vehicles":
          optionApi = "getVehicles";
          break;
        case "types":
          optionApi = "getVehicleTypes";
          break;
        case "brands_models":
          optionApi = "getVehicleBrands";
          break;
        case "locations":
          optionApi = "getLocations";
          break;
        default:
          break;
      }
      return optionApi;
    },
    editZone(item) {
      this.zoneId = item.zone_id;
      this.showZonesModal = true;
    },
    hideModal() {
      this.showZonesModal = false;
    },
    refreshTable() {
      this.showBrandModal = false;
      this.showVehicleTypeModal = false;
      this.routeModal = false;
      this.showZonesModal = false;
      this.rateModal = false;
      this.$refs["ref-table-vehicles"].refresh();
    },

    classCardSelected(index) {
      const classes = {
        // 'cursor-pointer hover-card': !this.isModalShow,
        // 'border border-2': true,
        // 'text-white': this.cardSelected === index && this.isLightSkin,
        // 'bg-click': this.cardSelected === index,
        // 'bg-content-card':true,
        "cursor-pointer hover-card": true,
        // 'text-white':this.adsSaleIdSelected === index && this.isLightSkin,
        "bg-click": this.cardSelected === index,
      };

      return classes;
    },

    async changeSelectedCard(option) {
      try {
        if (this.cardSelected == option) return;
        this.addPreloader();
        (this.isBusy = true), (this.cardSelected = option);
        this.$emit("changeSelectedCard", this.cardSelected);
        this.$refs["ref-table-vehicles"].refresh();
        // await this.getCurrentClientProject();
      } catch (error) {
        this.showErrorSwal();
      } finally {
        this.isBusy = false;
        this.removePreloader();
      }
    },

    addRoute() {
      this.routeId = null;
      this.routeModal = true;
    },
    locationsCode() {
      this.showLocationCodesModal = true;
    },
    editRoute(item) {
      this.routeId = item.id;
      this.routeModal = true;
    },

    addRate() {
      this.rateId = null;
      this.rateModal = true;
    },

    addBrand() {
      this.brandId = null;
      this.showBrandModal = true;
    },

    editBrand(item) {
      this.brandId = item.id;
      this.showBrandModal = true;
    },

    addVehicleType() {
      this.vehicleTypeId = null;
      this.showVehicleTypeModal = true;
    },

    editVehicleType(item) {
      this.vehicleTypeId = item.id;
      this.showVehicleTypeModal = true;
    },

    async getRegisteredQantitiesOfCards() {
      try {
        const { data } =
          await TravelRouteService.getRegisteredQantitiesOfCards();
        console.log("counters: ", data);
        if (data.length) {
          this.optionsCard[0].quantity = data[0].rates;
          this.optionsCard[1].quantity = data[0].routes;
          this.optionsCard[2].quantity = data[0].zones;
          this.optionsCard[3].quantity = data[0].locations;
        }
      } catch (error) {
        throw error;
      }
    },

    addVehicle() {
      this.vehicleId = null;
      this.showVehicleSidebar = true;
    },

    editVehicle(id) {
      this.vehicleId = id;
      this.showVehicleSidebar = true;
    },
  },
};
</script>

<style lang="scss" scoped>
%bg_pack {
  background: #6a3093; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #a044ff,
    #6a3093
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #a044ff,
    #6a3093
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.dark-layout {
  .bg-click {
    background-color: #0090e7 !important;
  }
}

.bg-click {
  .title-pack {
    color: #fff;
  }
  .icon-pack {
    color: #fff;
  }
  .status_pack {
    background: #0202022b;
  }
  .status_pack_project {
    background: #02020254;
  }
  .status_pack_project_light {
    background: #fff;
  }
  .bg-status {
    background: #00000040;
    font-weight: bold;
  }
  .bg-status-dark {
    background: #00000040;
    font-weight: bold;
  }
  color: #fff;
  @extend %bg_pack;
}
.hover-card,
.cancel {
  transition: 300ms;
}
.parent-card {
  margin-top: 3px;
  height: 115px;

  .hover-card:hover {
    @extend %bg_pack;
    color: white;
    border: none !important;
    .title-pack {
      color: #fff;
    }
    .icon-pack {
      color: #fff;
    }
    .is-view {
      display: block;
    }
  }
  .hover-card:hover {
    + .is-view {
      display: block;
    }
  }
}
</style>